import type { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import styles from './loader.module.css';

export const Loader: FunctionComponent<PropsWithChildren> = ({ children }): ReactElement => (
  <div className={styles.loader__container}>
    <div className={styles.loader} />
    {children ? <div className={styles.loader__content}>{children}</div> : null}
  </div>
);
